import {
  Grid,
  SpaceBetween,
  Box,
  TextContent,
  ColumnLayout,
  FormField,
  Select,
  Tiles,
  TilesProps,
} from "@cloudscape-design/components-themed";
import { isEqual, isUndefined } from "lodash";
import {
  ConfirmationMerchantInfoItem,
  ConfirmResult,
} from "../../../features/api-interfaces";
import {
  CONFIRMATION_RESULT,
  LABELS,
  ADDRESS_TAX,
  ADDRESS_TSR,
  ADDRESS_APP,
} from "../constants";
import {
  getApiConfirmationResult,
  getConfirmationResultDict,
  formatAddress,
  getAddress,
  getAddressButtonLabel,
} from "../util";

interface ICompanyAddressConfirmation {
  merchant: ConfirmationMerchantInfoItem;
  updateItem: (merchant: ConfirmationMerchantInfoItem) => void;
  isMerchantRegistered: boolean;
  confirmResultList: ConfirmResult[];
}

/**
 * 事業者住所確認
 */
const CompanyAddressConfirmation = (props: ICompanyAddressConfirmation) => {
  const { merchant, updateItem, isMerchantRegistered, confirmResultList } =
    props;
  const isRegistered = confirmResultList.find((item) =>
    isEqual(item.individualHandlingReason, merchant.individualHandlingReason)
  )?.confirmationResult;
  const tsrAddress = getAddress(
    merchant.addressList,
    Number(ADDRESS_TSR.value)
  );
  const taxAddress = getAddress(
    merchant.addressList,
    Number(ADDRESS_TAX.value)
  );
  const appAddress = getAddress(
    merchant.addressList,
    Number(ADDRESS_APP.value)
  );
  const addressItems: TilesProps.TilesDefinition[] = [
    ...merchant.addressList.map((address) => {
      const isAddressNotFound = isUndefined(
        getAddress(merchant.addressList, address.addressType)
      );

      return {
        value: String(address.addressType ?? ""),
        label: getAddressButtonLabel(address.addressType ?? -1),
        disabled: isAddressNotFound || isMerchantRegistered || isRegistered,
      };
    }),
  ];

  return (
    <SpaceBetween direction={"vertical"} size={"s"}>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.CONFIRMATION_RESULT}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Select
                selectedOption={getConfirmationResultDict(
                  merchant.confirmationResult
                )}
                options={CONFIRMATION_RESULT}
                filteringType={"none"}
                onChange={({ detail: { selectedOption } }) => {
                  updateItem({
                    ...merchant,
                    confirmationResult: getApiConfirmationResult(
                      selectedOption.value!
                    ),
                  });
                }}
                disabled={isMerchantRegistered || isRegistered}
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box margin={"s"} float={"left"}>
          <TextContent>
            <h5>{LABELS.CONFIRMATION_ADDRESS_TITLE}</h5>
          </TextContent>
        </Box>
      </SpaceBetween>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Grid gridDefinition={[{ colspan: 9 }, { colspan: 3 }]}>
          <SpaceBetween direction={"vertical"} size={"s"}>
            <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
              <Box margin={"s"}>
                <TextContent>
                  <h5>{LABELS.TSR_NAME}</h5>
                </TextContent>
              </Box>
              <Box padding={"s"}>{formatAddress(tsrAddress)}</Box>
            </Grid>
            <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
              <Box margin={"s"}>
                <TextContent>
                  <h5>{LABELS.TAX_NAME}</h5>
                </TextContent>
              </Box>
              <Box padding={"s"}>{formatAddress(taxAddress)}</Box>
            </Grid>
            <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
              <Box margin={"s"}>
                <TextContent>
                  <h5>{LABELS.MERCHANT_APPLICATION_NAME}</h5>
                </TextContent>
              </Box>
              <Box padding={"s"}>{formatAddress(appAddress)}</Box>
            </Grid>
          </SpaceBetween>
          <Tiles
            items={addressItems}
            value={String(merchant.addressType ?? "")}
            onChange={({ detail: { value } }) => {
              updateItem({
                ...merchant,
                addressType: Number(value),
              });
            }}
            columns={1}
          />
        </Grid>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export default CompanyAddressConfirmation;
